<template>
  <div class="our aboutUs">
     <img src="/static/images/m/contact.jpg" alt="" class="banner">
     <p class="our_common_title">联系我们</p>       
     <div class="aboutUs_detail">
       <div class="aboutUs_item">
         <div class="aboutUs_item_text">
            <p>上海帝景卫浴设备有限公司</p>
            <p>地址( ADD )：上海市徐汇区桂箐路7号G7-B201</p>
            <p>电话( TEL )：021-52366166 52366178</p>
            <p>网址：http://dking.vapps.me/dist/index.html</p>
            <p>电子邮件( E-MAIL )：<a href='mailto:wellness@dkingsh.com'>wellness@dkingsh.com</a></p>
            <p>微信公众号：dkingsh</p>
            <img src="/static/images/m/contact_code.png" alt="" class="contact_code">
         </div>
       </div>
     </div>
  </div>
</template>

<script>
/*import Swiper from 'Swiper'
import swipercss from '../../../node_modules/_swiper@3.4.2@swiper/dist/css/swiper.min.css'*/
export default {
  name: 'app',
  data(){
    return{
      cremq:false,
      cpcs:true
    }
  },
  watch:{
    '$route':function(to,from){
      //this.getconfig()
    }
  },
  mounted:function(){

  }
}
</script>

<style scoped>
.aboutUs{

}
.banner{
  width: 100%;
  display: block;
}
.our_common_title{
  font-size: 0.36rem;
  font-weight: bold;
  color: #000;
  padding:0.3rem 0.2rem 0.5rem;
}
.aboutUs_detail{
  padding: 0rem 0.2rem 0;
}
.aboutUs_item{
  margin-bottom: 0.5rem;
}
.aboutUs_item:last-child{
  margin-bottom: 0;
}
.item_tittle{
  height: 0.7rem;
  line-height: 0.7rem;
  padding-right: 0.26rem;
  padding-left: 0.1rem;
  background-color: #f8f7f7;
  display: inline-block;
  border-radius: 0.04rem;
  font-size: 0.24rem;
  color: #000000;
  margin-bottom: 0.4rem;
}
.item_tittle .num{
 width: 0.5rem;
 height: 0.5rem;
 color: #fff;
 font-weight: bold;
 text-align: center;
 line-height: 0.5rem;
 display: inline-block;
 background-color: #3478f7;
 border-radius: 0.04rem;
 margin-right: 0.24rem;
}
.aboutUs_item_text{
  font-size: 0.24rem;
  color: #000;
  line-height: 200%;
}
.aboutUs_item_text a{
  color: #000;
}
.contact_code{
  width: 2.44rem;
  display: block;
  margin: 0 auto;
  margin-top: 0.4rem;
}

</style>


// WEBPACK FOOTER //
// src/components/mobile/contact.vue